/** TODO this should function as an interceptor from the server - the server knows which things are or are not auditable */
import { GrowlService } from 'components/chrome/Growl';
import Server from 'data/Server';


const DEFAULT_LIFE_MS = 6000;


class AuditService {
  constructor() {
    this.growlSvc = new GrowlService.Factory().create();
    this.server = new Server.Factory().create();
  }

  log(msg) {
    this.growlSvc.show({
      severity: 'info',
      summary: 'Event logged',
      detail: `${msg}\n(${this.server.user_email()})`,
      life: DEFAULT_LIFE_MS,
    });
  }
}


AuditService.Factory = class {
  create() {
    return _instance;
  }
}


const _instance = new AuditService();


export default AuditService;

